import { render, staticRenderFns } from "./authUser.vue?vue&type=template&id=5824fe16&"
import script from "./authUser.vue?vue&type=script&lang=js&"
export * from "./authUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports